var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.sim)?_c('sim'):_c('fim')}
var staticRenderFns = []

export { render, staticRenderFns }